/**
 * ProductWithHelpers -> ProductWithHelpers = CURRENT | LOAN | SAVINGS
 * externalProduct -> ExternalProduct = INSURANCE | SECURITIES | LEASING | BUILDINGSOCIETY | PENSION
 * product -> ProductWithHelpers | ExternalProduct | CardAccount
 * */

import type { GeorgeFeatureConfig } from '@shared/george-config';
import type { Account } from '@shared/products-types';
import { getFeatureConfig } from '@luna/feature-config';

import { usePAPIProducts } from './papi/usePAPIProducts';
import { useLegacyProducts } from './legacy/useLegacyProducts';
import type { AccountStrategy } from '../configurations/accountsStrategySingleton';
import type {
    AccountOrAccountOfExternalProduct,
    ProductWithHelpers,
} from '../types/productHelpers';

// all service functions by product type should use the derivedType field to narrow down the type.
// type ProductWithHelpers = { id: string; derivedType: 'CURRENT' | 'SAVINGS' | 'LOAN' };
// type ExternalProduct = { id: string; derivedType: 'INSURANCE' | 'SECURITIES' };
// type CardAccount = { id: string; derivedType: 'CURRENT' | 'SAVINGS' | 'LOAN' };
// type Product = ProductWithHelpers | ExternalProduct | CardAccount;

type UseProductsReturn<BaseType, UnderlyingData> = {
    products: ProductWithHelpers<BaseType, UnderlyingData>[];
    productsById: Record<string, ProductWithHelpers<BaseType, UnderlyingData>>;
    refetch: () => Promise<void>;
    isPending: boolean;
    error?: Error | null;
};

/** @deprecated do not introduce more usages of this hook in @retail or @business packages! */
export const useProducts = <
    BaseType extends AccountOrAccountOfExternalProduct = Account,
    UnderlyingData = unknown,
>(
    strategy?: AccountStrategy,
): UseProductsReturn<BaseType, UnderlyingData> => {
    const hook = getFeatureConfig<GeorgeFeatureConfig, boolean>(
        ({ products }) => products.relyOnPAPIEndpointsForData,
    )
        ? usePAPIProducts
        : useLegacyProducts;

    return hook(strategy);
};
